import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import Product from "../components/Product";
import PPEForm from "../components/PPEForm";
import Specifications from "../components/Specifications";

// Import data from helpers
import { covidTestKitsProducts } from "../helpers/covid-test-kits/products";
import { covidTestKitsFormFields } from "../helpers/covid-test-kits/formConfig";
import { covidTestKitsSpecifications } from "../helpers/covid-test-kits/specifications";

const CovidTestKits: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "COVID-19 Test Kits",
      path: "/covid-19-test-kits.html",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Page Title and Products - Unified Container */}
        <div className="w-full py-8 bg-white">
          <div className="page-container">
            <h1 className="page-title">
              COVID-19 Test Kits in Bulk
            </h1>
            <p className="page-description">
              Get back to business and life thanks to Abbott BinaxNow™ COVID-19
              Tests! Not everyone is vaccinated yet, so these trusted and
              easy-to-use tests can detect COVID-19 in both symptomatic and
              asymptomatic people, providing added peace of mind when going back
              to the office or to events, conferences & meetings.
            </p>
            
            {/* Product Grid */}
            <div className="mt-8">
              <Product products={covidTestKitsProducts} aspectRatio="covid" />
            </div>
          </div>
        </div>

        {/* Get Started Form */}
        <PPEForm
          title="Get Started"
          description="Get in touch today or call"
          phoneNumber="844-599-8654"
          fields={covidTestKitsFormFields}
          formName="COVID-19 Test Kits PPE.us"
        />

        {/* Test Types Information - White Background with responsive padding */}
        <div className="w-full py-4 bg-white">
          <div className="px-5 ml-0 md:ml-[3%]" style={{ paddingLeft: "20px" }}>
            <div className="specification-small">
              <h5>We carry three (3) different BinaxNOW COVID-19 tests, so there is one for your specific needs:</h5>
              <p>- Home Test</p>
              <p>- Home Test with Digital Health Pass</p>
              <p>- Onsite Test</p>
            </div>
          </div>

          {/* Specifications - Remove the extra margin/padding here */}
          <Specifications
            title="Specifications"
            items={covidTestKitsSpecifications}
          />
        </div>
      </main>
    </div>
  );
};

export default CovidTestKits;
